export interface IViewSettings {
    isDefault: boolean
}

export default abstract class ViewSettings {
    abstract get isDefault(): boolean
}
